export const GET_AUDIENCE_COUNT_START = 'GET_AUDIENCE_COUNT_START';
export const GET_AUDIENCE_COUNT_SUCCESS =
  'GET_AUDIENCE_COUNT_SUCCESS';
export const GET_AUDIENCE_COUNT_ERROR = 'GET_AUDIENCE_COUNT_ERROR';
